/*
 * File: cell-hierachy.ts
 * File Created: 2024-03-01 03:16:51
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-01-16 12:11:46
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import {
    BaseTableBodyCell,
    defaultTableBodyCellData,
    ITableBodyCellData,
} from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import { ObjectHelper } from "@root/core/utilities/object-helper";
import {
    IQuickHierachySummary,
    IQuickUnit,
    IQuickUnitGeneralizedSubTree,
    QuickHelper,
} from "@root/core/utilities/quick-helper";
import { StringHelper } from "@root/core/utilities/string-helper";
import { Component, Inject, Prop } from "vue-property-decorator";
import { defaultData, ICellHierachyData } from "../cell-hierachy/cell-hierachy";

interface IGeneratedValueUnit {
    quick: IQuickUnit;
    value: any;
}

@Component
@UITag.setDefault({
    uiAlign: "r",
    uiProvideRow: true,
})
export default class CellSingleHierachy extends BaseTableBodyCell {
    @Prop({ type: Object, required: true })
    summary!: IQuickHierachySummary;

    @Prop({ type: Object, required: false })
    declare data: (ICellHierachyData & ITableBodyCellData) | undefined;
    get mergedData() {
        return {
            ...defaultTableBodyCellData,
            ...defaultData,
            ...this.data,
        };
    }

    @Inject({ default: null })
    readonly prefix!: string | null;

    get generatedValue(): IGeneratedValueUnit[] {
        const summary = this.summary;
        let results: any[] = [];
        if (summary == null) return results;

        /// ignore single child
        let value = ObjectHelper.deepClone(this.value);
        let firstParent: boolean = true;
        let tempParent: IQuickUnitGeneralizedSubTree[] | null = [summary.back];
        do {
            const quick = tempParent[0];

            if (firstParent) {
                firstParent = false;
            } else {
                /// the parent should be singualize
                value = value[StringHelper.camelize(quick.propertyName)];
            }
            if (value == null) break;

            const { path, clientPath, icon, title } = quick.quick;
            results.unshift({
                quick: quick.quick,
                value,
            });
        } while ((tempParent = QuickHelper.getParents(tempParent[0])));

        /// handle drop last
        if (this.mergedData["drop-last"]) results.pop();

        return results;
    }

    static matchHierachy(summary: IQuickHierachySummary, value: any): boolean {
        let firstParent: boolean = true;
        let tempParent: IQuickUnitGeneralizedSubTree[] | null = [summary.back];
        do {
            const quick = tempParent[0];

            if (firstParent) {
                firstParent = false;
            } else {
                /// the parent should be singualize
                value = value[StringHelper.camelize(quick.propertyName)];
            }
            if (value == null) return false;
        } while ((tempParent = QuickHelper.getParents(tempParent[0])));

        return true;
    }
}
